import type React from 'react';
import { BaseReportElement } from '../BaseReportElement';
import { renderDefinitionListWithAddElementSlot } from '../renderHelpers';
import type {
    ContextForKind,
    EditorRenderRuntime,
    ElementDefinition,
    ElementContentRenderResult,
    ElementSettings,
    RenderContextKind,
    RenderRuntime,
} from '../types';
import type { StructurePath } from '../structurePath';

const ROOT_STRUCTURE_PATH: StructurePath = [];

export class TemplateElement extends BaseReportElement<RenderContextKind, ElementSettings> {
    static readonly elementType = 'template';

    static readonly compatibleContextKinds = ['project', 'measuring-point'] as const;

    private readonly definitions: ElementDefinition[];

    constructor(definitions: ElementDefinition[]) {
        super({});
        this.definitions = definitions;
    }

    protected normalizeSettings(rawSettings: ElementSettings): ElementSettings {
        return rawSettings;
    }

    protected shouldApplyEditorFrame(_runtime: EditorRenderRuntime): boolean {
        return false;
    }

    protected toCompatibleReactNode(
        ctx: ContextForKind<RenderContextKind>,
        runtime: RenderRuntime
    ): ElementContentRenderResult {
        const rendered = renderDefinitionListWithAddElementSlot(
            this.definitions,
            ctx,
            runtime,
            ROOT_STRUCTURE_PATH,
            ctx.kind,
            'template-root',
            gettext('ADD_PAGE')
        );

        return {
            // TODO: cant this be more efficient by not creating an extra fragment wrapper?
            // e.g. React.createElement(React.Fragment, {}, rendered.nodes)?
            node: <>{rendered.nodes}</>,
            ready: rendered.ready,
            hasRenderableContent: rendered.hasRenderableContent,
        };
    }
}
